var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 58,
    height: 66,
    viewBox: "0 0 58 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 16.8999C58 16.7999 58 16.6999 57.9 16.5999V16.4999C57.9 16.3999 57.8 16.2999 57.7 16.1999L41.7 0.199902C41.6 0.0999024 41.5 0.0999023 41.4 -9.76548e-05H41.3C41.2 -9.76548e-05 41.1 -9.76548e-05 41 -0.100098C41 -0.100098 41 -0.100098 40.9 -0.100098H13.8C10.6 -9.76548e-05 8 2.5999 8 5.7999V56.1999C8 59.3999 10.6 61.9999 13.8 61.9999H52.2C55.4 61.9999 58 59.3999 58 56.1999V16.8999C58 16.9999 58 16.9999 58 16.8999ZM54.6 15.9999H45.8C43.7 15.9999 42 14.2999 42 12.1999V3.3999L54.6 15.9999ZM52.2 59.9999H13.8C11.7 59.9999 10 58.2999 10 56.1999V5.7999C10 3.6999 11.7 1.9999 13.8 1.9999H40V12.1999C40 15.3999 42.6 17.9999 45.8 17.9999H56V56.1999C56 58.2999 54.3 59.9999 52.2 59.9999Z",
    fill: "#5BB3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19H33C33.6 19 34 18.6 34 18V13C34 12.4 33.6 12 33 12H17C16.4 12 16 12.4 16 13V18C16 18.6 16.4 19 17 19ZM18 14H32V17H18V14Z",
    fill: "#5BB3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23H17C16.4 23 16 23.4 16 24C16 24.6 16.4 25 17 25H49C49.6 25 50 24.6 50 24C50 23.4 49.6 23 49 23Z",
    fill: "#5BB3C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31H45C45.6 31 46 30.6 46 30C46 29.4 45.6 29 45 29H17C16.4 29 16 29.4 16 30C16 30.6 16.4 31 17 31Z",
    fill: "#5BB3C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47 35H17C16.4 35 16 35.4 16 36C16 36.6 16.4 37 17 37H47C47.6 37 48 36.6 48 36C48 35.4 47.6 35 47 35Z",
    fill: "#5BB3C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41H17C16.4 41 16 41.4 16 42C16 42.6 16.4 43 17 43H42C42.6 43 43 42.6 43 42C43 41.4 42.6 41 42 41Z",
    fill: "#5BB3C7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 49,
    width: 33,
    height: 17,
    rx: 4,
    fill: "#145374"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7 53.95H9.94C10.7067 53.95 11.3033 54.1433 11.73 54.53C12.1567 54.9167 12.37 55.4567 12.37 56.15C12.37 56.8433 12.1567 57.3833 11.73 57.77C11.3033 58.1567 10.7067 58.35 9.94 58.35H8.26V61H6.7V53.95ZM9.74 57.17C10.52 57.17 10.91 56.8333 10.91 56.16C10.91 55.8133 10.8133 55.5567 10.62 55.39C10.4267 55.2233 10.1333 55.14 9.74 55.14H8.26V57.17H9.74ZM13.3797 53.95H16.1197C16.8864 53.95 17.5464 54.09 18.0997 54.37C18.653 54.65 19.0764 55.0533 19.3697 55.58C19.663 56.1067 19.8097 56.7367 19.8097 57.47C19.8097 58.2033 19.663 58.8367 19.3697 59.37C19.083 59.8967 18.663 60.3 18.1097 60.58C17.5564 60.86 16.893 61 16.1197 61H13.3797V53.95ZM16.0097 59.74C17.5097 59.74 18.2597 58.9833 18.2597 57.47C18.2597 55.9633 17.5097 55.21 16.0097 55.21H14.9397V59.74H16.0097ZM21.0066 61V53.95H25.7666V55.18H22.5466V56.8H25.5666V58.03H22.5466V61H21.0066Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.3ca99ebb883457c15340a7e12a714ae7.svg";
export { ForwardRef as ReactComponent };